<style lang="stylus">
    .underline-menu
        display flex
        height 40px
        border-bottom 1px solid var(--border-color-gray2)
        .menu-block
            flex 1
            display flex
            justify-content center
            align-items center
            cursor pointer
            min-width 0
            svg
                width 16px
                height 16px
                color var(--svg-color-primary)
                outline none !important
            p
                display flex
                align-items center
                height 100%
                position relative
                font-size 14px
                color var(--text-color-primary)
                max-width calc(100% - 10px)
                span
                    textOverflow()
                >.ivu-tooltip
                    width 16px
                    height 16px
                    display block
                    margin-left 4px
                    font-weight 400
                    .ivu-tooltip-rel
                        height 16px
                    .ivu-tooltip-popper {
                        .ivu-tooltip-content {
                            .ivu-tooltip-arrow {
                                border-bottom-color: var(--bg-color-tips)
                            }
                            .ivu-tooltip-inner {
                                width: 180px;
                                padding: 6px 12px;
                                min-height: auto;
                                border-radius: 8px;
                                text-align: left;
                                line-height: 16px;
                                text-indent: 0;
                                background-color var(--bg-color-tips)
                                box-shadow $box-shadow
                            }
                        }
                    }
            &:hover
                p
                    color var(--themeColor)
                svg
                    color var(--themeColor)
            &.active
                p
                    color var(--themeColor)
                    font-weight 700
                    &::after
                        content ""
                        position absolute
                        bottom -1px
                        left 0
                        width 100%
                        height 2px
                        background var(--themeColor)
                svg
                    position relative
                    color var(--themeColor)
</style>

<template>
    <div class="underline-menu">
        <div class="menu-block" v-for="item in list" :class="{ active: value == item.id }" @click="setMenuIndex(item.id)">
            <p>
                <span :title="item.label">
                    {{ item.label }}
                </span>
                <Tooltip v-if="item.tippy" :content="item.tippy" max-width="180">
                    <iconSymbol name="question" />
                </Tooltip>
            </p>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";

    @Component
    export default class UnderLineMenu extends Vue {
        @Prop()
        list;
        @Prop()
        value;

        setMenuIndex(index: number) {
            this.$emit("input", index);
            this.$emit("changeMenu", index);
        }
        created() {}
        mounted() {}
    }
</script>
<i18n>
{
    "zh": {},
    "en": {},
    "fr": {},
    "de": {},
    "jp": {},
    "es": {},
    "pt": {},
    "it": {},
    "tw": {},
    "kr": {}
}
</i18n>
